module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('title', [_vm._v("Collection of Sand: Essays")]), _vm._v(" "), _c('meta', {
    attrs: {
      "content": "text/html; charset=utf-8",
      "http-equiv": "Content-Type"
    }
  }), _vm._v(" "), _c('link', {
    attrs: {
      "href": "../styles/stylesheet.css",
      "rel": "stylesheet",
      "type": "text/css"
    }
  }), _vm._v(" "), _c('h2', {
    staticClass: "EB04MainHead",
    attrs: {
      "id": "page_v"
    }
  }, [_vm._v("Contents")]), _vm._v(" "), _c('p', {
    staticClass: "EB15ContentsText",
    attrs: {
      "id": "col0000019"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/translator"
    }
  }, [_c('em', [_vm._v("Translator’s Introduction")])])]), _vm._v(" "), _c('p', {
    staticClass: "EB15ContentsText",
    attrs: {
      "id": "col0000020"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/authorspresentation"
    }
  }, [_c('em', [_vm._v("The Author’s Presentation of the Volume")])])]), _vm._v(" "), _c('p', {
    staticClass: "EB15ContentsText",
    attrs: {
      "id": "col0000021"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/noteontext"
    }
  }, [_c('em', [_vm._v("A Note on the Text")])]), _c('br'), _c('br')]), _vm._v(" "), _c('p', {
    staticClass: "EB15ContentsText",
    attrs: {
      "id": "col0000022"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/part001"
    }
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("COLLECTION OF SAND")])]), _c('br'), _c('br')]), _vm._v(" "), _c('p', {
    staticClass: "EB15ContentsText",
    attrs: {
      "id": "col0000023"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/part001"
    }
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("I EXHIBITIONS—EXPLORATIONS")])])]), _vm._v(" "), _c('p', {
    staticClass: "EB15ContentsTextIndent",
    attrs: {
      "id": "col0000024"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/chapter001"
    }
  }, [_c('em', [_vm._v("Collection of Sand")])])]), _vm._v(" "), _c('p', {
    staticClass: "EB15ContentsTextIndent",
    attrs: {
      "id": "col0000025"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/chapter002"
    }
  }, [_c('em', [_vm._v("How New the New World Was")])])]), _vm._v(" "), _c('p', {
    staticClass: "EB15ContentsTextIndent",
    attrs: {
      "id": "col0000026"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter003",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("The Traveller in the Map")])])]), _vm._v(" "), _c('p', {
    staticClass: "EB15ContentsTextIndent",
    attrs: {
      "id": "col0000027"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter004",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("The Museum of Wax Monsters")])])]), _vm._v(" "), _c('p', {
    staticClass: "EB15ContentsTextIndent",
    attrs: {
      "id": "col0000028"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter005",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("The Dragon Tradition")])])]), _vm._v(" "), _c('p', {
    staticClass: "EB15ContentsTextIndent",
    attrs: {
      "id": "col0000029"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter006",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Before the Alphabet")])])]), _vm._v(" "), _c('p', {
    staticClass: "EB15ContentsTextIndent",
    attrs: {
      "id": "col0000030"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter007",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("The Wonders of the Popular Press")])])]), _vm._v(" "), _c('p', {
    staticClass: "EB15ContentsTextIndent",
    attrs: {
      "id": "col0000031"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter008",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("A Novel Inside a Painting")])])]), _vm._v(" "), _c('p', {
    staticClass: "EB15ContentsTextIndent",
    attrs: {
      "id": "col0000032"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter009",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Say It with Knots")])])]), _vm._v(" "), _c('p', {
    staticClass: "EB15ContentsTextIndent",
    attrs: {
      "id": "col0000033"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter010",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Writers Who Draw")])]), _c('br'), _c('br')]), _vm._v(" "), _c('p', {
    staticClass: "EB15ContentsText",
    attrs: {
      "id": "col0000034"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/part002",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("II THE EYE’S RAY")])])]), _vm._v(" "), _c('p', {
    staticClass: "EB15ContentsTextIndent",
    attrs: {
      "id": "col0000035"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter011",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("In Memory of Roland Barthes")])])]), _vm._v(" "), _c('p', {
    staticClass: "EB15ContentsTextIndent",
    attrs: {
      "id": "col0000036"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter012",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Day-flies in the Fortress")])])]), _vm._v(" "), _c('p', {
    staticClass: "EB15ContentsTextIndent",
    attrs: {
      "id": "col0000037"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter013",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("The Pig and the Archaeologist")])])]), _vm._v(" "), _c('p', {
    staticClass: "EB15ContentsTextIndent",
    attrs: {
      "id": "col0000038"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter014",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("The Narrative of Trajan’s Column")])])]), _vm._v(" "), _c('p', {
    staticClass: "EB15ContentsTextIndent",
    attrs: {
      "id": "col0000039"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter015",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("The Written City: Inscriptions and Graffiti")])])]), _vm._v(" "), _c('p', {
    staticClass: "EB15ContentsTextIndent",
    attrs: {
      "id": "col0000040"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter016",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Thinking the City: The Measure of Spaces")])])]), _vm._v(" "), _c('p', {
    staticClass: "EB15ContentsTextIndent",
    attrs: {
      "id": "col0000041"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter017",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("The Redemption of Objects")])])]), _vm._v(" "), _c('p', {
    staticClass: "EB15ContentsTextIndent",
    attrs: {
      "id": "col0000042"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter018",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Light in Our Eyes")])]), _c('br'), _c('br')]), _vm._v(" "), _c('p', {
    staticClass: "EB15ContentsText",
    attrs: {
      "id": "page_vi"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/part003",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("III ACCOUNTS OF THE FANTASTIC")])])]), _vm._v(" "), _c('p', {
    staticClass: "EB15ContentsTextIndent",
    attrs: {
      "id": "col0000043"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter019",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("The Adventures of Three Clockmakers and Three Automata")])])]), _vm._v(" "), _c('p', {
    staticClass: "EB15ContentsTextIndent",
    attrs: {
      "id": "col0000044"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter020",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Fairy Geography")])])]), _vm._v(" "), _c('p', {
    staticClass: "EB15ContentsTextIndent",
    attrs: {
      "id": "col0000045"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter021",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("The Archipelago of Imaginary Places")])])]), _vm._v(" "), _c('p', {
    staticClass: "EB15ContentsTextIndent",
    attrs: {
      "id": "col0000046"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter022",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Stamps from States of Mind")])])]), _vm._v(" "), _c('p', {
    staticClass: "EB15ContentsTextIndent",
    attrs: {
      "id": "col0000047"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter023",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("The Encyclopedia of a Visionary")])]), _c('br'), _c('br')]), _vm._v(" "), _c('p', {
    staticClass: "EB15ContentsText",
    attrs: {
      "id": "col0000048"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/part004",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("IV THE SHAPE OF TIME")])])]), _vm._v(" "), _c('p', {
    staticClass: "EB15ContentsTextIndent",
    attrs: {
      "id": "col0000049"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter024",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Japan:")])])]), _vm._v(" "), _c('p', {
    staticClass: "EB15ContentsTextIndent",
    attrs: {
      "id": "col0000050"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter025",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("The Old Woman in the Purple\n\t\t\t\t\tKimono")])])]), _vm._v(" "), _c('p', {
    staticClass: "EB15ContentsTextIndent",
    attrs: {
      "id": "col0000051"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter026",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("The Obverse of the\n\t\t\t\tSublime")])])]), _vm._v(" "), _c('p', {
    staticClass: "EB15ContentsTextIndent",
    attrs: {
      "id": "col0000052"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter027",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("The Wooden Temple")])])]), _vm._v(" "), _c('p', {
    staticClass: "EB15ContentsTextIndent",
    attrs: {
      "id": "col0000053"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter028",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("The Thousand Gardens")])])]), _vm._v(" "), _c('p', {
    staticClass: "EB15ContentsTextIndent",
    attrs: {
      "id": "col0000054"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter029",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("The Moon Chasing the\n\t\t\t\tMoon")])])]), _vm._v(" "), _c('p', {
    staticClass: "EB15ContentsTextIndent",
    attrs: {
      "id": "col0000055"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter030",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("The Sword and the Leaves")])])]), _vm._v(" "), _c('p', {
    staticClass: "EB15ContentsTextIndent",
    attrs: {
      "id": "col0000056"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter031",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("The Pinballs of Solitude")])])]), _vm._v(" "), _c('p', {
    staticClass: "EB15ContentsTextIndent",
    attrs: {
      "id": "col0000057"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter032",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Eros and Discontinuity")])])]), _vm._v(" "), _c('p', {
    staticClass: "EB15ContentsTextIndent",
    attrs: {
      "id": "col0000058"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter033",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("The Ninety-Ninth Tree")])]), _c('br'), _c('br')]), _vm._v(" "), _c('p', {
    staticClass: "EB15ContentsTextIndent",
    attrs: {
      "id": "col0000059"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter034",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Mexico:")])])]), _vm._v(" "), _c('p', {
    staticClass: "EB15ContentsTextIndent",
    attrs: {
      "id": "col0000060"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter035",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("The Shape of the Tree")])])]), _vm._v(" "), _c('p', {
    staticClass: "EB15ContentsTextIndent",
    attrs: {
      "id": "col0000061"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter036",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Time and Branches")])])]), _vm._v(" "), _c('p', {
    staticClass: "EB15ContentsTextIndent",
    attrs: {
      "id": "col0000062"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter037",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("The Forest and the Gods")])]), _c('br'), _c('br')]), _vm._v(" "), _c('p', {
    staticClass: "EB15ContentsTextIndent",
    attrs: {
      "id": "col0000063"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter038",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Iran:")])])]), _vm._v(" "), _c('p', {
    staticClass: "EB15ContentsTextIndent",
    attrs: {
      "id": "col0000064"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter039",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("The Mihrab")])])]), _vm._v(" "), _c('p', {
    staticClass: "EB15ContentsTextIndent",
    attrs: {
      "id": "col0000065"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter040",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("The Flames within the\n\t\t\t\tFlames")])])]), _vm._v(" "), _c('p', {
    staticClass: "EB15ContentsTextIndent",
    attrs: {
      "id": "col0000066"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter041",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("The Sculptures and the\n\t\t\t\t\tNomads")])]), _c('br'), _c('br')]), _vm._v(" "), _c('p', {
    staticClass: "EB15ContentsTextIndent"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/abouttheauthor",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("About the Author")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-9d8ca3d6","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/toc.vue
// module id = 60
// module chunks = 0